<div class="container my-5">
    <h1 class="container text-center mt-3">Formación</h1>
    <hr class="my-5">
    <p>Desarrollar la formación continua de las(os) integrantes de la Red en materia psico-espiritual, gestión organizacional - operativa y de autocuidado.</p>
    <h2 class="text-center mt-5 mb-3">Jornadas de salud</h2>
    <ul>
        <li><p>Prevención</p></li>
        <li><p>Medicina integrativa, cirugías gratuitas</p></li>
    </ul>

</div>

<br class="mb-5">